module Meevo.Plugins.Register {
    "use strict";

    export class PaymentOptionsSection extends Meevo.Plugins.Register.RegisterSectionBase {
        constructor(
            registerContext: Meevo.Plugins.Register.RegisterContext,
            private modalService: Meevo.Components.Modal.IModalService
        ) {
            super(RegisterSectionTypeEnum.PaymentOptions, registerContext, "paymentOptions", Register.RegisterSectionCatTypeEnum.Payment);
        }

        reset() {
            this.registerContext.isCreditMode = false;
        }

        selectPaymentMethod(paymentCategory: RegisterPaymentCat) {
            if (paymentCategory.paymentCategory === Model.PaymentCategoryEnum.PaymentPlan) {
                let existingPaymentPlanPayment = this.registerContext.paymentPlanService.
                    getExistingPaymentPlanPaymentLine(this.registerContext);
                if (existingPaymentPlanPayment) {
                    this.registerContext.selectPaymentLine(existingPaymentPlanPayment);
                    return;
                }

                if (_(this.registerContext.sale.saleLines).all(saleLine => {
                    return !this.registerContext.paymentPlanService.canBeAddedToPaymentPlan(saleLine)
                })){
                    this.modalService.alert("MESSAGE_CANNOT_SELECT_PAYMENT_PLAN");
                    return;
                }

            }
            else if (paymentCategory.sectionType === RegisterSectionTypeEnum.Self &&
                this.registerContext.saleHasExternalTips()) {
                return this.modalService.alert("MESSAGE_NO_SELF_PAY_WITH_TIPPY")
            }

            if (paymentCategory.isDisabled) {
                this.modalService.alert(paymentCategory.disabledMessage);
                return;
            }

            this.registerContext.selectPaymentSection(paymentCategory.sectionType, true);
        }
    }
}